import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import { ArrowLeft, Phone, Mail, MapPin, Wrench } from "lucide-react";
import { fmtDate, fmtTime } from "@/lib/format";

export default function CustomerDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      const r = await api.get(`/customers/${id}`);
      setData(r.data);
    })();
  }, [id]);

  if (!data) return <div className="text-slate-500">Loading…</div>;
  const { customer, jobs } = data;

  return (
    <div className="space-y-5">
      <Link to="/customers" className="inline-flex items-center text-sm text-slate-600 hover:text-slate-900 font-semibold">
        <ArrowLeft className="w-4 h-4 mr-1" /> Back to customers
      </Link>

      <div className="bg-white rounded-2xl border border-slate-200 p-5 sm:p-6">
        <div className="flex items-start gap-4">
          <div className="h-14 w-14 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center font-bold text-xl flex-shrink-0">
            {customer.name.charAt(0).toUpperCase()}
          </div>
          <div className="min-w-0">
            <h1 className="text-2xl font-bold" data-testid="customer-detail-name">{customer.name}</h1>
            <div className="mt-2 space-y-1.5 text-sm text-slate-600">
              {customer.phone && <div className="flex items-center gap-2"><Phone className="w-4 h-4" />{customer.phone}</div>}
              {customer.email && <div className="flex items-center gap-2"><Mail className="w-4 h-4" />{customer.email}</div>}
              {customer.address && <div className="flex items-center gap-2"><MapPin className="w-4 h-4" />{customer.address}</div>}
            </div>
          </div>
        </div>
      </div>

      <div>
        <h2 className="text-lg font-bold mb-3" style={{ fontFamily: "Outfit" }}>Job history</h2>
        {jobs.length === 0 ? (
          <div className="bg-white rounded-2xl border border-slate-200 p-6 text-center text-slate-500">
            <Wrench className="w-10 h-10 mx-auto text-slate-300 mb-2" />
            No jobs yet for this customer.
          </div>
        ) : (
          <div className="space-y-2">
            {jobs.map((j) => (
              <Link key={j.id} to={`/jobs/${j.id}`} data-testid={`customer-job-${j.id}`}>
                <div className="bg-white rounded-2xl border border-slate-200 p-4 hover:border-blue-300 transition-all active:scale-[0.99] mb-2">
                  <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0">
                      <div className="font-semibold truncate">{j.title}</div>
                      <div className="text-sm text-slate-500 mt-0.5">
                        {j.scheduled_date ? fmtDate(j.scheduled_date) : "No date"} {j.scheduled_time && `• ${fmtTime(j.scheduled_time)}`}
                      </div>
                    </div>
                    <StatusBadge status={j.status} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
